const getServerCookieUrl = `https://app.gztv.com:7443/gzbn-auth/auth/getGzbnCookieId`;
const dailyOutRecordUrl = `https://app.gztv.com:7443/plus-cloud-interact-app/app/dailyOutRecord/save`;

function dailyOutRecord(params) {
  params.cookieId = getBrowserCookie("gzbn_cookie_id");
  let xhr = new XMLHttpRequest();
  xhr.open("POST", dailyOutRecordUrl, true);
  xhr.setRequestHeader("Content-type", "application/json; charset=utf-8");
  xhr.withCredentials = true;
  xhr.send(JSON.stringify(params));
}

function getBrowserCookie(name) {
  let cookieArr = document.cookie.split("; ");
  for (let i = 0; i < cookieArr.length; i++) {
    let cookiePair = cookieArr[i].split("=");
    if (cookiePair[0] === name) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}

function gzbnDailyCount() {
  if (!getBrowserCookie("gzbn_cookie_id")) {
    let xhr = new XMLHttpRequest();
    xhr.open("GET", getServerCookieUrl, true);
    xhr.withCredentials = true;
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== XMLHttpRequest.DONE || xhr.status !== 200) {
        return;
      }

      if (!getBrowserCookie("gzbn_cookie_id")) {
        document.cookie = `gzbn_cookie_id=${xhr.responseText};path=/`;
      }

      dailyOutRecord({ tenantCode: "hcplus" });
    };
    xhr.send();
  } else {
    dailyOutRecord({ tenantCode: "hcplus" });
  }
}

gzbnDailyCount();
